var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-modal"},[_c('div',{staticClass:"header-modal"},[(_vm.isClose)?_c('div',{staticClass:"icon",on:{"click":function($event){return _vm.$parent.close()}}},[_c('img',{attrs:{"src":require("@/assets/icon/x.svg")}})]):_vm._e()]),_c('div',{staticClass:"body-modal",class:{
    'has-padding': _vm.hasPadding
  }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }